import { useQuery } from '@apollo/client';
import { useState } from 'react';

import type {
  GetLineItemsV5CampaignManagerQuery,
  GetLineItemsV5CampaignManagerQueryVariables,
} from '../../../../../apis/graphql';
import { GET_LINE_ITEMS_V5_CAMPAIGN_MANAGER } from '../queries';
import { getLineItemsToRefetchForCacheUpdate } from './utils';

export type UseRefetchUpdatedLineItems = {
  refetchLineItems: (lineItemIds: string[]) => Promise<void>;
  isLoading: boolean;
};

export const useRefetchUpdatedLineItems = (): UseRefetchUpdatedLineItems => {
  const [isLoading, setIsLoading] = useState(false);
  const { refetch } = useQuery<GetLineItemsV5CampaignManagerQuery, GetLineItemsV5CampaignManagerQueryVariables>(
    GET_LINE_ITEMS_V5_CAMPAIGN_MANAGER,
    {
      skip: true,
    }
  );

  const refetchLineItems = async (lineItemIds: string[]): Promise<void> => {
    const lineItemToRefetchForCacheUpdate = getLineItemsToRefetchForCacheUpdate(lineItemIds);

    if (lineItemToRefetchForCacheUpdate.length) {
      setIsLoading(true);

      await refetch({ idList: lineItemToRefetchForCacheUpdate }).finally(() => {
        setIsLoading(false);
      });
    }
  };

  return { refetchLineItems, isLoading };
};
